import { jsx as _jsx } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Button } from "@bookips/sds";
import Link from "next/link";
const ShortcutList = (param)=>{
    let { items , className , onItemClick , variant ="default"  } = param;
    const handleClick = (item)=>{
        mixpanelEvent("Category Board Item Clicked", {
            "Item Type": "Footer",
            "Item Name": item.itemTitle
        });
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick();
    };
    return /*#__PURE__*/ _jsx("div", {
        className: cn("h-12 shrink-0 border-t border-gray-100 bg-white", className),
        children: /*#__PURE__*/ _jsx("div", {
            className: cn("h-full max-w-[1200px] mx-auto flex items-center gap-2 overflow-x-auto", variant === "tablet" && "px-[6.5px]", variant === "mobile" && "px-5", variant === "default" && "px-6 justify-center"),
            children: items.map((item)=>/*#__PURE__*/ _jsx(Link, {
                    href: item.itemLink,
                    onClick: ()=>handleClick(item),
                    children: /*#__PURE__*/ _jsx(Button, {
                        variant: "text",
                        color: "secondary",
                        size: "sm",
                        className: "whitespace-nowrap",
                        children: item.itemTitle
                    })
                }, item.itemSeq))
        })
    });
};
export default ShortcutList;
